module.exports = __webpack_public_path__ + "media/96.23a1e304.wav";